import { useI18n } from "../lib/i18n";

const IMAGES = [
  {
    url: "https://images.unsplash.com/photo-1578104820981-ee156b36c521?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    label: "ENGINE",
    span: "md:col-span-6 md:row-span-2 h-[300px] md:h-[600px]",
  },
  {
    url: "https://images.unsplash.com/photo-1554863798-d89af6030d7d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    label: "WORKSHOP",
    span: "md:col-span-3 h-[280px]",
  },
  {
    url: "https://images.unsplash.com/photo-1637640125496-31852f042a60?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    label: "TOOLS",
    span: "md:col-span-3 h-[280px]",
  },
  {
    url: "https://images.unsplash.com/photo-1673153069781-a0b210f6232c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    label: "EXHAUST",
    span: "md:col-span-3 h-[280px]",
  },
  {
    url: "https://images.unsplash.com/photo-1668037069509-ba4c569475b1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    label: "FINISHED",
    span: "md:col-span-3 h-[280px]",
  },
];

export const Gallery = () => {
  const { t } = useI18n();

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 bg-[#0A0A0C] border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="mb-14">
          <div className="font-condensed uppercase text-xs tracking-[0.4em] text-[#E51E1A] mb-4">
            · {t.gallery.kicker}
          </div>
          <h2 className="font-headings uppercase text-5xl md:text-6xl lg:text-7xl text-white leading-none">
            {t.gallery.title} <span className="text-[#E51E1A]">{t.gallery.titleAccent}</span>
          </h2>
          <p className="mt-5 text-zinc-400 text-lg max-w-xl">{t.gallery.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-3">
          {IMAGES.map((img, i) => (
            <div
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`group relative overflow-hidden ${img.span}`}
            >
              <img
                src={img.url}
                alt={img.label}
                className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C] via-[#0A0A0C]/30 to-transparent" />
              <div className="absolute top-4 left-4 px-3 py-1 bg-[#E51E1A] font-headings uppercase text-xs tracking-widest text-white">
                {img.label}
              </div>
              <div className="absolute bottom-4 right-4 font-headings text-zinc-600 text-2xl">
                0{i + 1}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
